import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingSharedComponent } from './loading.component';

@NgModule({
    declarations: [
        LoadingSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LoadingSharedComponent
    ]
})

export class LoadingSharedModule {}
